import { Text, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Center } from 'native-base';
import React from 'react';

import { CustomerWalletPoints } from '../../../../../../../../components/CustomerWalletPoints';

export declare namespace ChartTextTypes {
  export type Props = {
    accountNumber: number;
    label?: string;
    baseLabel?: string;
    percentage?: number;
    value?: number;
    hideLabel?: boolean;
    hidePercentage?: boolean;
  };
}

export const ChartText: React.FC<ChartTextTypes.Props> = ({
  accountNumber,
  baseLabel,
  label,
  percentage,
  value,
  hideLabel = false,
  hidePercentage = false,
}) => {
  const content = (
    <>
      <CustomerWalletPoints accountNumber={accountNumber} preventPadding />
      <Text fontSize={Typography['fontsize.xxl']}>{Utils.Mask.ScaleMoney(value, 1_000_000)}</Text>
      <Text fontSize={Typography['fontsize.md']} variant="semibold">
        {baseLabel}
      </Text>
      <HStack space={Spacing['stack.quarck']}>
        {!hideLabel && (
          <Text color="neutral.medium" fontSize={Typography['fontsize.md']}>
            {label}
          </Text>
        )}
        {!hidePercentage && (
          <Text color="neutral.medium" fontSize={Typography['fontsize.md']}>
            {Utils.Mask.Percentage(percentage)}
          </Text>
        )}
      </HStack>
    </>
  );

  return (
    <foreignObject
      width="100%"
      height="100%"
      z={-1}
      display="flex"
      style={{ alignItems: 'center', justifyContent: 'center' }}>
      <Center height="full" width="full" alignItems="center">
        <VStack space={Spacing['stack.quarck']} alignItems="center">
          {content}
        </VStack>
      </Center>
    </foreignObject>
  );
};
